import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { getPlanBadgeStyle } from '../../utils/plan-badge';

@Component({
  selector: 'app-subscription-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full"
          [ngClass]="style.container">
      {{ key }}
    </span>
  `,
})
export class SubscriptionBadgeComponent {
  @Input() key: string | undefined = '';

  get style() {
    return getPlanBadgeStyle(this.key);
  }
}
